import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import CookieBanner from '../../components/feature/CookieBanner';
import StructuredData from '../../components/base/StructuredData';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

const FaqPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);

    document.title = 'Preguntas Frecuentes Vaciado de Pisos Mollet | JUSTCLEAN';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Resuelve tus dudas sobre vaciado de pisos, limpieza Diógenes, precios y plazos en Mollet del Vallès. Todas las respuestas a tus preguntas ☎️ 602 36 59 96'
      );
    }
  }, []);

  const faqCategories = [
    {
      category: 'Sobre el Servicio',
      questions: [
        {
          pregunta: '¿Qué servicios ofrecéis en Mollet del Vallès?',
          respuesta:
            'En JUSTCLEAN ofrecemos servicios completos de vaciado de pisos y casas, vaciado de locales comerciales, retirada de muebles y electrodomésticos, limpieza por síndrome de Diógenes y suciedad extrema, pintura final y pequeñas reparaciones. Trabajamos en Mollet del Vallès y toda la comarca del Vallès Oriental, incluyendo Parets del Vallès, Montmeló, Montornès del Vallès, La Llagosta, Martorelles, Granollers y Santa Perpètua de Mogoda.',
        },
        {
          pregunta: '¿En qué zonas de Mollet del Vallès trabajáis?',
          respuesta:
            'Trabajamos en todos los barrios de Mollet del Vallès: Centre, Plana Lledó, Can Borrell, Santa Rosa, Lourdes, Riera Seca, Can Pantiquet y Gallecs. También ofrecemos nuestros servicios en toda la comarca del Vallès Oriental y municipios cercanos como Parets del Vallès, Montmeló, Montornès, La Llagosta, Martorelles, Granollers, Santa Perpètua de Mogoda, Sant Fost de Campsentelles, Palau-solità i Plegamans, Lliçà de Vall y Lliçà d\'Amunt.',
        },
      ],
    },
    {
      category: 'Precios y Presupuestos',
      questions: [
        {
          pregunta: '¿Cuánto cuesta vaciar un piso en Mollet del Vallès?',
          respuesta:
            'El precio del vaciado de un piso depende de varios factores: tamaño de la vivienda, cantidad de enseres a retirar, nivel de limpieza necesario, accesibilidad (ascensor, escaleras) y ubicación exacta en Mollet del Vallès o comarca. Como referencia, un piso estándar de 70-80m² puede costar entre 400€ y 800€. Te ofrecemos siempre un presupuesto personalizado y sin compromiso tras evaluar tu caso específico. Llámanos al 602 36 59 96 para una valoración inicial gratuita.',
        },
        {
          pregunta: '¿El presupuesto es gratuito y sin compromiso?',
          respuesta:
            'Sí, absolutamente. Todos nuestros presupuestos son completamente gratuitos y sin ningún tipo de compromiso. Puedes contactarnos por teléfono al 602 36 59 96, por WhatsApp o a través de nuestro formulario web. Si lo prefieres, visitamos el piso o local en Mollet del Vallès o cualquier localidad del Vallès Oriental sin coste alguno para darte un presupuesto detallado y ajustado a tus necesidades reales.',
        },
        {
          pregunta: '¿Qué incluye el precio del vaciado?',
          respuesta:
            'Nuestro precio incluye: retirada completa de todos los muebles, electrodomésticos y enseres, carga y transporte, gestión legal de residuos con certificado, limpieza básica posterior (barrido y recogida de escombros), y mano de obra especializada. Si necesitas servicios adicionales como limpieza profunda, desinfección, pintura o pequeñas reparaciones, te lo incluimos en el presupuesto personalizado. No hay costes ocultos ni sorpresas.',
        },
      ],
    },
    {
      category: 'Proceso y Plazos',
      questions: [
        {
          pregunta: '¿Cuánto tiempo tarda el vaciado de un piso?',
          respuesta:
            'El tiempo necesario depende del tamaño y estado del piso. Un piso estándar de 70-80m² con cantidad normal de enseres se vacía en 1-2 días laborables. Pisos más grandes (100-120m²) pueden requerir 2-3 días. En casos de acumulación importante o síndrome de Diógenes, el proceso puede extenderse de 3 a 7 días según el nivel de acumulación. Siempre te damos una estimación precisa de tiempo tras la visita inicial en Mollet del Vallès o tu localidad.',
        },
        {
          pregunta: '¿Ofrecéis servicio urgente o en fin de semana?',
          respuesta:
            'Sí, disponemos de servicio urgente 24 horas para situaciones que requieren atención inmediata en Mollet del Vallès y comarca. También trabajamos en fines de semana y festivos si es necesario. El servicio urgente tiene un pequeño suplemento sobre el precio estándar. Si necesitas un vaciado urgente por desahucio, entrega de llaves inminente o cualquier otra emergencia, llámanos al 602 36 59 96 y te atendemos de inmediato.',
        },
        {
          pregunta: '¿Necesito estar presente durante el vaciado?',
          respuesta:
            'No es imprescindible que estés presente durante todo el proceso de vaciado. Muchos clientes en Mollet del Vallès nos confían las llaves y nosotros realizamos el trabajo de forma autónoma. Eso sí, es recomendable que estés presente al inicio para indicarnos qué objetos conservar (si los hay) y al final para verificar que todo está correcto. Si no puedes estar presente, coordinamos con administradores de fincas, inmobiliarias o familiares sin problema.',
        },
      ],
    },
    {
      category: 'Síndrome de Diógenes',
      questions: [
        {
          pregunta: '¿Cómo trabajáis en casos de síndrome de Diógenes?',
          respuesta:
            'Los casos de síndrome de Diógenes requieren un trato especial que dominamos tras años de experiencia. Trabajamos con máxima discreción y confidencialidad, utilizando vehículos sin rotulación si es necesario. Nuestro equipo está formado para tratar estas situaciones con sensibilidad y respeto. Coordinamos con servicios sociales y familias, adaptamos el ritmo de trabajo a las necesidades emocionales de la persona afectada, y realizamos limpieza profunda y desinfección completa. Cada caso en Mollet del Vallès o comarca lo tratamos de forma personalizada.',
        },
        {
          pregunta: '¿Garantizáis la discreción en casos delicados?',
          respuesta:
            'Absolutamente. La discreción es uno de nuestros valores fundamentales, especialmente en casos de síndrome de Diógenes, suciedad extrema o situaciones sociales delicadas. Utilizamos vehículos sin rotulación, trabajamos en horarios que minimicen la exposición, coordinamos con comunidades de vecinos para evitar molestias, y todo nuestro equipo firma acuerdos de confidencialidad. Jamás comentamos los casos con terceros. Tu privacidad y la de tu familia están completamente protegidas.',
        },
      ],
    },
    {
      category: 'Gestión de Residuos',
      questions: [
        {
          pregunta: '¿Qué hacéis con los muebles y objetos que retiráis?',
          respuesta:
            'Gestionamos todos los enseres de forma responsable y legal. Los muebles y objetos en buen estado los donamos a organizaciones benéficas y ONGs de Mollet del Vallès y comarca (Cáritas, Cruz Roja, etc.). Los electrodomésticos y residuos especiales los llevamos a puntos limpios autorizados para su correcto reciclaje. Los residuos no aprovechables se gestionan según normativa vigente. Te entregamos certificado de gestión de residuos si lo necesitas para trámites administrativos o legales.',
        },
        {
          pregunta: '¿Coordinais con la comunidad de vecinos?',
          respuesta:
            'Sí, tenemos amplia experiencia coordinando con comunidades de propietarios en Mollet del Vallès y comarca. Nos encargamos de solicitar los permisos necesarios, reservar el ascensor si es preciso, proteger zonas comunes durante el trabajo, y limpiar cualquier suciedad que podamos generar en escaleras o portal. Trabajamos en horarios que minimicen las molestias a los vecinos y mantenemos comunicación fluida con administradores de fincas y presidentes de comunidad.',
        },
      ],
    },
  ];

  const allQuestions = faqCategories.flatMap((cat, catIndex) =>
    cat.questions.map((q, qIndex) => ({
      ...q,
      id: catIndex * 100 + qIndex,
    }))
  );

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: allQuestions.map((q) => ({
      '@type': 'Question',
      name: q.pregunta,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.respuesta,
      },
    })),
  };

  return (
    <div className={`min-h-screen transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <StructuredData data={structuredData} />
      <Header />

      <main>
        <section
          className="relative h-96 flex items-center justify-center"
          style={{
            backgroundImage:
              'url(https://public.readdy.ai/ai/img_res/8459240a153c9c21d16c3fa75f8c3ab6.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-dark/60"></div>
          <div className="relative z-10 text-center px-4">
            <nav className="text-white/70 text-sm mb-4">
              <Link to="/" className="hover:text-white">
                Inicio
              </Link>
              <span className="mx-2">&gt;</span>
              <span className="text-white">FAQ</span>
            </nav>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
              Preguntas Frecuentes sobre Vaciado de Pisos en Mollet
            </h1>
            <p className="text-white/90 text-xl max-w-3xl mx-auto">
              Resuelve todas tus dudas sobre nuestros servicios de vaciado, limpieza y gestión de residuos en Mollet del Vallès y comarca
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            {faqCategories.map((category, catIndex) => (
              <div key={catIndex} className="mb-16">
                <h2 className="text-3xl font-bold text-dark mb-8 pb-4 border-b-2 border-primary">
                  {category.category}
                </h2>

                <div className="space-y-4">
                  {category.questions.map((faq, qIndex) => {
                    const faqId = catIndex * 100 + qIndex;
                    return (
                      <div key={faqId} className="border-b border-gray-200 last:border-b-0">
                        <button
                          onClick={() => setOpenFaq(openFaq === faqId ? null : faqId)}
                          className="w-full flex items-center justify-between py-6 text-left hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                        >
                          <h3 className="text-lg font-semibold text-dark pr-8">{faq.pregunta}</h3>
                          <i
                            className={`ri-arrow-down-s-line text-2xl text-primary transition-transform duration-200 flex-shrink-0 ${
                              openFaq === faqId ? 'rotate-180' : ''
                            }`}
                          ></i>
                        </button>

                        <div
                          className={`overflow-hidden transition-all duration-300 ${
                            openFaq === faqId ? 'max-h-96 pb-6' : 'max-h-0'
                          }`}
                        >
                          <div className="text-gray-700 leading-relaxed">{faq.respuesta}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-16 bg-secondary/10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white rounded-2xl p-12 shadow-lg">
              <i className="ri-question-line text-6xl text-primary mb-6"></i>
              <h2 className="text-3xl font-bold text-dark mb-4">¿No Encuentras tu Pregunta?</h2>
              <p className="text-gray-700 text-lg mb-8">
                Si tienes alguna duda que no hemos resuelto aquí, no dudes en contactarnos. Estaremos encantados de ayudarte y resolver todas tus preguntas sobre vaciado de pisos, limpieza por síndrome de Diógenes o cualquier otro servicio en Mollet del Vallès.
              </p>

              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <a
                  href="tel:+34602365996"
                  className="inline-flex items-center justify-center space-x-2 bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-fill text-xl"></i>
                  <span>Llamar Ahora</span>
                </a>

                <Link
                  to="/contacto"
                  className="inline-flex items-center justify-center space-x-2 border-2 border-primary text-primary px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-line text-xl"></i>
                  <span>Contactar</span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-dark mb-4">También te Puede Interesar</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <Link
                to="/servicios"
                className="group bg-secondary/10 rounded-xl p-8 hover:bg-secondary/20 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-service-line text-5xl text-primary mb-4"></i>
                <h3 className="text-xl font-bold text-dark mb-3 group-hover:text-primary transition-colors">
                  Nuestros Servicios
                </h3>
                <p className="text-gray-700 mb-4">
                  Descubre todos los servicios de vaciado y limpieza que ofrecemos en Mollet del Vallès
                </p>
                <span className="text-primary font-semibold inline-flex items-center">
                  Ver servicios
                  <i className="ri-arrow-right-line ml-2"></i>
                </span>
              </Link>

              <Link
                to="/empresa"
                className="group bg-secondary/10 rounded-xl p-8 hover:bg-secondary/20 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-building-line text-5xl text-primary mb-4"></i>
                <h3 className="text-xl font-bold text-dark mb-3 group-hover:text-primary transition-colors">
                  Sobre Nosotros
                </h3>
                <p className="text-gray-700 mb-4">
                  Conoce nuestra empresa, valores y más de 10 años de experiencia en el sector
                </p>
                <span className="text-primary font-semibold inline-flex items-center">
                  Conocer más
                  <i className="ri-arrow-right-line ml-2"></i>
                </span>
              </Link>

              <Link
                to="/contacto"
                className="group bg-secondary/10 rounded-xl p-8 hover:bg-secondary/20 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-customer-service-line text-5xl text-primary mb-4"></i>
                <h3 className="text-xl font-bold text-dark mb-3 group-hover:text-primary transition-colors">
                  Contacto
                </h3>
                <p className="text-gray-700 mb-4">
                  Solicita tu presupuesto sin compromiso o consúltanos cualquier duda
                </p>
                <span className="text-primary font-semibold inline-flex items-center">
                  Contactar
                  <i className="ri-arrow-right-line ml-2"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
      <CookieBanner />
    </div>
  );
};

export default FaqPage;